<template>
  <div class="rate-summary">
    <CardApiError
      v-if="apiError"
      :error-text="$t('APP.RATING_SUMMARY.API_ERROR')"
      @retry="getInfo"
    />
    <Card v-else :is-loading="isLoading">
      <div class="rate-summary__content">
        <RateOverallStats
          :total-count="rateSummary.totalCount"
          :rate-average="rateSummary.rate"
        />
        <RatePercentage :rate-percentages="ratePercentages" />
      </div>
    </Card>
  </div>
</template>

<script>
import Reviews from '@/api/app-reviews';
import packageNameMixin from '@/mixins/packageName';
import packageNameWatch from '@/mixins/apps/packageNameWatch';
import CardApiError from '@@/common/CardApiError';
import RatePercentage from './RatePercentage';
import RateOverallStats from './RateOverallStats';
import Card from '@@/common/Card';
import percentage from '@/utils/percentage';
export default {
  name: 'RateSummary',

  components: {
    CardApiError,
    RatePercentage,
    RateOverallStats,
    Card,
  },

  mixins: [packageNameMixin, packageNameWatch],

  data() {
    return {
      isLoading: false,
      rateSummary: {},
      apiError: false,
    };
  },

  computed: {
    ratePercentages() {
      const { totalCount, ratesCount = [] } = this.rateSummary;
      return ratesCount.map(rate => percentage(rate, totalCount));
    },
  },

  created() {
    this.getInfo();
  },

  methods: {
    getInfo() {
      this.getRateSummary();
    },

    getRateSummary() {
      this.isLoading = true;
      this.apiError = false;
      return Reviews.getRateSummary(this.packageName)
        .then(rateSummary => {
          this.rateSummary = rateSummary;
        })
        .catch(({ message }) => {
          this.apiError = true;
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.rate-summary {
  &__content {
    display: flex;
    direction: ltr;
    flex-wrap: wrap;
  }
}
</style>
